import { createReducer, createActions } from "reduxsauce";
import {
  REDUX_STATE,
  requestReducerFunc,
  failureReducerFunc,
  successReducerFunc,
  setReducerFunc,
} from "./redux-structure";

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  createGroup: ["data", "prefixKey"],
  updateGroup: ["data", "prefixKey"],
  deleteGroup: ["data", "prefixKey"],
  changeGroupPhoto: ["data", "prefixKey"],
  removeMemberGroup: ["data", "prefixKey"],
  addMemberGroup: ["data", "prefixKey"],
  muteGroupNotification: ["data", "prefixKey"],
  addAdmin: ["data", "prefixKey"],
  deleteGroupOnlyMe: ["groupId", "prefixKey"],

  groupInfoSuccess: ["data"],
  groupInfoFailure: ["error", "data"],
  groupInfoSet: ["data"],
});

export const GroupInfoTypes = Types;
export const GroupInfoActions = Creators;
export default Creators;

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
  ...REDUX_STATE,

  newGroupId: null, // New group id

  groupHasNewMember: null,
  dataMemberToAdmin: null,
  updatingGroupData: {}, // Use this when changing group info: name, avatar, draft message
  updateGroupCategory: null, // Change group category (unread, favorite, channel, group, personal)
  deleteGroup: null,
};

/* ------------- Selector ------------- */
export const GroupInfoSelectors = {
  getUpdatingGroup: state => state.groupInfoRedux.updatingGroupData,
  getDeleteGroup: state => state.groupInfoRedux.deleteGroup,
  getGroupHasNewMember: state => state.groupInfoRedux.groupHasNewMember,
};

/* ------------- Reducers ------------- */
const request = (state = INITIAL_STATE) =>
  requestReducerFunc({
    ...state,
    newGroupId: null,
  });

const set = (state = INITIAL_STATE, action) => setReducerFunc(state, action);

const success = (state = INITIAL_STATE, action) => successReducerFunc(state, action);

const failure = (state = INITIAL_STATE, action) => failureReducerFunc(state, action);

/* ------------- Mapping ------------- */
export const HANDLERS = {
  [Types.CREATE_GROUP]: request,
  [Types.DELETE_GROUP]: request,
  [Types.UPDATE_GROUP]: request,
  [Types.CHANGE_GROUP_PHOTO]: request,
  [Types.REMOVE_MEMBER_GROUP]: request,
  [Types.ADD_MEMBER_GROUP]: request,
  [Types.MUTE_GROUP_NOTIFICATION]: request,
  [Types.ADD_ADMIN]: request,
  [Types.DELETE_GROUP_ONLY_ME]: request,

  [Types.GROUP_INFO_SET]: set,
  [Types.GROUP_INFO_SUCCESS]: success,
  [Types.GROUP_INFO_FAILURE]: failure,
};

/* ------------- Hookup Reducers To Types ------------- */
export const GroupInfoReducer = createReducer(INITIAL_STATE, HANDLERS);
